import React, { useEffect, useState } from 'react';
import { extendesClassname } from 'helpers';
import { TabsStyle } from './Tabs.styled';
import TabPane, { TabPaneProps } from './TabPane';

type TabsProps = {
    activeKey?: string;
    defaultActiveKey?: string;
    tabPosition?: 'top' | 'left' | 'right';
    children: React.ReactNode;
    onChange?: (currentTabKey: string | number) => void;
} & Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'onChange'>;

const TABS_DIRECTION_TABS = {
    top: 'column',
    left: 'row',
    bottom: 'column-reverse',
    right: 'row-reverse',
};
const TABS_DIRECTION_NAV = {
    top: 'row',
    left: 'column',
    bottom: 'row',
    right: 'column',
};

function Tabs({ children, activeKey, defaultActiveKey, tabPosition = 'top', onChange, ...props }: TabsProps) {
    const [tabKey, setTabKey] = useState<number | null>(null);
    const [defaultActiveWorkDone, setDefaultActiveWorkDone] = useState(false);

    const tabPanes = React.Children.toArray(children).filter(
        (child): child is React.ReactElement<TabPaneProps> => React.isValidElement(child) && child.type === TabPane
    );

    const onChangeTab = (index: number, tabKey: React.Key) => {
        setTabKey(index);

        if (onChange) {
            onChange((tabKey as string) || index);
        }
    };

    // first time
    useEffect(() => {
        const init = () => {
            if (!defaultActiveWorkDone && defaultActiveKey && tabPanes.find((f) => f.props.tabKey === defaultActiveKey)) {
                const activeKey = tabPanes.findIndex((f) => f.props.tabKey === defaultActiveKey);
                if (activeKey) {
                    console.log('activeKey');
                    setTabKey(activeKey);
                }

                setDefaultActiveWorkDone(true);
                console.log('setDefaultActiveWorkDone');
                return;
            }

            if (!defaultActiveWorkDone) setDefaultActiveWorkDone(true);
        };

        init();
    }, [defaultActiveKey, tabPanes]);

    // after fist time
    useEffect(() => {
        const handleActiveTab = () => {
            if (defaultActiveWorkDone && activeKey && tabPanes.find((f) => f.props.tabKey === activeKey)) {
                console.log('if');
                return setTabKey(tabPanes.findIndex((f) => f.props.tabKey === activeKey));
            }

            if (defaultActiveWorkDone && tabKey === null) return setTabKey(0);
        };

        handleActiveTab();
    }, [activeKey, defaultActiveWorkDone, tabPanes, tabKey]);

    if (!tabKey && tabKey !== 0) return null;

    return (
        <TabsStyle directionTabs={TABS_DIRECTION_TABS[tabPosition]} directionNav={TABS_DIRECTION_NAV[tabPosition]} {...props}>
            <div className='tabs-bar'>
                <div className='tabs-nav'>
                    {tabPanes.map(
                        (tab, index) =>
                            tab.props?.tab && (
                                <button
                                    type='button'
                                    key={index}
                                    tabIndex={index}
                                    className={index === tabKey ? 'tabs-tab tabs-tab-active' : 'tabs-tab'}
                                    disabled={tab.props?.disabled}
                                    onClick={() => onChangeTab(index, tab.props.tabKey)}
                                >
                                    {tab.props.tab}
                                </button>
                            )
                    )}
                </div>
            </div>

            {tabPanes[tabKey].props?.tab && (
                <div aria-labelledby={'tab-' + (tabKey + 1)} {...extendesClassname(['tabs-content', tabPanes[tabKey].props?.className])}>
                    {tabPanes[tabKey].props?.children}
                </div>
            )}
        </TabsStyle>
    );
}

export default Tabs;
